import { Action } from "@ngrx/store";
import { type } from "../../../util";
import {
  Diagnosis360,
  DiagnosisGroup,
  DiagnosisGroupItem,
  DiagnosisItem,
} from "./diagnosis.model";

/**
 * Action Types
 */
export const ActionTypes = {
  SELECT_GROUP: type("[PE-Diagnosis] Select Group"),
  SELECT_ITEM: type("[PE-Diagnosis] Select Group Item"),
  UPDATE_OPTIONS: type("[PE-Diagnosis] Update Options"),
  LOAD_ITEMS: type("[PE-Diagnosis] Load Items"),
  LOAD_ITEMS_SUCCESS: type("[PE-Diagnosis] Load Items Success"),
  LOAD_ITEMS_FAIL: type("[PE-Diagnosis] Load Items Fail"),
  ADD_ITEM: type("[PE-Diagnosis] Add Item"),
  ADD_ITEM_SUCCESS: type("[PE-Diagnosis] Add Item Success"),
  ADD_ITEM_FAIL: type("[PE-Diagnosis] Add Item Fail"),
  SAVE_ORTHO_ITEM: type("[PE-Diagnosis] Save Ortho Item"),
  SAVE_ORTHO_ITEM_SUCCESS: type("[PE-Diagnosis] Save Ortho Item Success"),
  SAVE_ORTHO_ITEM_FAIL: type("[PE-Diagnosis] Save Ortho Item Fail"),
  UPDATE_ITEM: type("[PE-Diagnosis] Update Item"),
  UPDATE_ITEM_SUCCESS: type("[PE-Diagnosis] Update Item Success"),
  UPDATE_ITEM_FAIL: type("[PE-Diagnosis] Update Item Fail"),
  DELETE_ITEM: type("[PE-Diagnosis] Delete Item"),
  DELETE_ITEM_SUCCESS: type("[PE-Diagnosis] Delete Item Success"),
  DELETE_ITEM_FAIL: type("[PE-Diagnosis] Delete Item Fail"),
  DELETE_ORTHO_ITEM: type("[PE-Diagnosis] Delete Ortho Item"),
  DELETE_ORTHO_ITEM_SUCCESS: type("[PE-Diagnosis] Delete Ortho Item Success"),
  DELETE_ORTHO_ITEM_FAIL: type("[PE-Diagnosis] Delete Ortho Item Fail"),
  SORT_ITEMS: type("[PE-Diagnosis] Sort Items"),
  SORT_ITEMS_SUCCESS: type("[PE-Diagnosis] Sort Items Success"),
  SORT_ITEMS_FAIL: type("[PE-Diagnosis] Sort Items Fail"),
  SHOW_LIST: type("[PE-Diagnosis] Show Item List"),
  HIDE_LIST: type("[PE-Diagnosis] Hide Item List"),
  UPDATE_360: type("[PE-Diagnosis] Update 360 Diagram"),
  UPDATE_360_SUCCESS: type("[PE-Diagnosis] Update 360 Diagram Success"),
  UPDATE_360_FAIL: type("[PE-Diagnosis] Update 360 Diagram Fail"),
};

/**
 * Actions
 */
export class SelectGroupAction implements Action {
  type = ActionTypes.SELECT_GROUP;
  constructor(public payload: DiagnosisGroup) {}
}

export class SelectGroupItemAction implements Action {
  type = ActionTypes.SELECT_ITEM;
  constructor(public payload: DiagnosisGroupItem) {}
}

export class UpdateOptionsAction implements Action {
  type = ActionTypes.UPDATE_OPTIONS;
  constructor(public payload: any) {}
}

export class LoadItemsAction implements Action {
  type = ActionTypes.LOAD_ITEMS;
}

export class LoadItemsSuccessAction implements Action {
  type = ActionTypes.LOAD_ITEMS_SUCCESS;
  constructor(public payload?: any) {}
}

export class LoadItemsFailAction implements Action {
  type = ActionTypes.LOAD_ITEMS_FAIL;
}

export class AddItemAction implements Action {
  type = ActionTypes.ADD_ITEM;
  constructor(public payload: DiagnosisItem) {}
}

export class AddItemSuccessAction implements Action {
  type = ActionTypes.ADD_ITEM_SUCCESS;
  constructor(public payload: DiagnosisItem) {}
}

export class AddItemFailAction implements Action {
  type = ActionTypes.ADD_ITEM_FAIL;
  constructor(public payload?: any) {}
}

export class SaveOrthoAction implements Action {
  type = ActionTypes.SAVE_ORTHO_ITEM;
  constructor(public payload?: any) {}
}

export class SaveOrthoSuccessAction implements Action {
  type = ActionTypes.SAVE_ORTHO_ITEM_SUCCESS;
  constructor(public payload: DiagnosisItem) {}
}

export class SaveOrthoFailAction implements Action {
  type = ActionTypes.SAVE_ORTHO_ITEM_FAIL;
  constructor(public payload?: any) {}
}

export class UpdateItemAction implements Action {
  type = ActionTypes.UPDATE_ITEM;
  constructor(public payload: DiagnosisItem) {}
}

export class UpdateItemSuccessAction implements Action {
  type = ActionTypes.UPDATE_ITEM_SUCCESS;
  constructor(public payload: DiagnosisItem) {}
}

export class UpdateItemFailAction implements Action {
  type = ActionTypes.UPDATE_ITEM_FAIL;
  constructor(public payload?: any) {}
}

export class DeleteItemAction implements Action {
  type = ActionTypes.DELETE_ITEM;
  constructor(public payload: DiagnosisItem) {}
}

export class DeleteItemSuccessAction implements Action {
  type = ActionTypes.DELETE_ITEM_SUCCESS;
  constructor(public payload: DiagnosisItem) {}
}

export class DeleteItemFailAction implements Action {
  type = ActionTypes.DELETE_ITEM_FAIL;
  constructor(public payload?: any) {}
}

export class DeleteOrthoItemAction implements Action {
  type = ActionTypes.DELETE_ORTHO_ITEM;
  constructor(public payload: string) {}
}

export class DeleteOrthoItemSuccessAction implements Action {
  type = ActionTypes.DELETE_ORTHO_ITEM_SUCCESS;
  constructor(public payload?: any) {}
}

export class DeleteOrthoItemFailAction implements Action {
  type = ActionTypes.DELETE_ORTHO_ITEM_FAIL;
  constructor(public payload?: any) {}
}

export class SortItemsAction implements Action {
  type = ActionTypes.SORT_ITEMS;
  constructor(public payload: DiagnosisItem[]) {}
}

export class SortItemsSuccessAction implements Action {
  type = ActionTypes.SORT_ITEMS_SUCCESS;
  constructor(public payload?: any) {}
}

export class SortItemsFailAction implements Action {
  type = ActionTypes.SORT_ITEMS_FAIL;
}

export class ShowListAction implements Action {
  type = ActionTypes.SHOW_LIST;
  constructor() {}
}

export class HideListAction implements Action {
  type = ActionTypes.HIDE_LIST;
  constructor() {}
}

export class Update360Action implements Action {
  type = ActionTypes.UPDATE_360;
  constructor(public payload: Diagnosis360) {}
}

export class Update360SuccessAction implements Action {
  type = ActionTypes.UPDATE_360_SUCCESS;
  constructor(public payload: Diagnosis360) {}
}

export class Update360FailAction implements Action {
  type = ActionTypes.UPDATE_360_FAIL;
  constructor(public payload?: any) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Action =
  | SelectGroupAction
  | SelectGroupItemAction
  | UpdateOptionsAction
  | LoadItemsAction
  | LoadItemsSuccessAction
  | LoadItemsFailAction
  | AddItemAction
  | AddItemSuccessAction
  | AddItemFailAction
  | SaveOrthoAction
  | SaveOrthoSuccessAction
  | SaveOrthoFailAction
  | UpdateItemAction
  | UpdateItemSuccessAction
  | UpdateItemFailAction
  | DeleteItemAction
  | DeleteItemSuccessAction
  | DeleteItemFailAction
  | DeleteOrthoItemAction
  | DeleteOrthoItemSuccessAction
  | DeleteOrthoItemFailAction
  | SortItemsAction
  | SortItemsSuccessAction
  | SortItemsFailAction
  | ShowListAction
  | HideListAction
  | Update360Action
  | Update360SuccessAction
  | Update360FailAction;



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/diagnosis.actions.ts